import React, { useEffect, useState } from "react";
import "./form.css";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";




const Form = () => {
    const [errorMessage, setErrorMessage] = useState(null)
    const [user, setUser] = useState({
        firstName: "",
        lastName: "",
        email: "",
        comemail: "",
        phone: "",
        org: "",
        help: "",
        budget: "",
        services: ""
    });


    const emptyInput = () => {
        let flag = 0;
        const errors = []; // Temporary array to collect error messages

        if (user.firstName === "") {
            errors.push("FirstName is empty");
            flag = 1;
        }
        if (user.lastName === "") {
            errors.push("LastName is empty");
            flag = 1;
        }
        if (user.email === "") {
            errors.push("Email is empty");
            flag = 1;
        }
        if (user.comemail === "") {
            errors.push("Company Email is empty");
            flag = 1;
        }
        if (user.phone === "") {
            errors.push("Phone is empty");
            flag = 1;
        }
        if (user.org === "") {
            errors.push("Organization is empty");
            flag = 1;
        }
        if (user.budget === "") {
            errors.push("Budget is empty");
            flag = 1;
        }
        if (user.services === "") {
            errors.push("Service is empty");
            flag = 1;
        }

        // Update the error message state with the collected errors
        setErrorMessage(errors);
        return flag;
    };

    const sendOmnisendEvent = () => {
        if (!window.omnisend) return;

        console.log("Sending identify...");

        // STEP 1: Identify FIRST
        window.omnisend.push([
            "identifyContact",
            {
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName
            }
        ]);

        // STEP 2: Delay BEFORE tracking
        setTimeout(() => {
            console.log("Sending event...");

            window.omnisend.push([
                "track",
                "contact_form_submitted",
                {
                    service: user.services,
                    budget: user.budget
                }
            ]);
        }, 1000); // IMPORTANT DELAY
    };

    const sendMessage = async () => {
        try {
            if (emptyInput() === 1) return;

            const eventId = uuidv4(); 

            if (window.fbq) {
                window.fbq('track', 'Lead', {}, { eventID: eventId });
            }

            const local = `${process.env.REACT_APP_BACKEND_URL}/sendemail`;

            const response = await axios.post(local, {
                ...user,
                eventId 
            });

            sendOmnisendEvent();

            alert("Message sent");

            setUser({
                firstName: "",
                lastName: "",
                email: "",
                comemail: "",
                phone: "",
                org: "",
                help: "",
                budget: "",
                services: ""
            });

            setErrorMessage(null);

            return response;

        } catch (error) {
            console.log(error);
        }
    }


    let name, value;
    const handleInput = (e) => {
        console.log(e);
        name = e.target.name;
        value = e.target.value;

        setUser({ ...user, [name]: value });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="contactForm-container">
                <div className="form-container">
                    <h1 className="form-topic">
                        Contact Us
                    </h1>
                    <span className="form-subtopic">
                        about a project or brief, an open position, or simply to get in touch, please enter your details below.
                    </span>
                    <div className="form-inputs">
                        <div className="row-inputs">
                            <input type="text" placeholder="First name"
                                value={user.firstName} onChange={handleInput} name="firstName" />
                            <input type="text" placeholder="Last name"
                                value={user.lastName} onChange={handleInput} name="lastName" />
                        </div>

                        <div className="row-inputs-2">
                            <input type="email" placeholder="Email address"
                                value={user.email} onChange={handleInput} name="email" />
                            <input type="email" placeholder=" Company Email address"
                                value={user.comemail} onChange={handleInput} name="comemail" />
                        </div>

                        <div className="row-inputs-3">
                            <input type="tel" placeholder="Phone number"
                                value={user.phone} onChange={handleInput} name="phone" />
                            <input type="text" placeholder="Organisation"
                                value={user.org} onChange={handleInput} name="org" />
                        </div>

                        <div className="row-inputs-4">
                            <input type="text" placeholder="Services you require"
                                value={user.services} onChange={handleInput} name="services" />

                            <input type="tel" placeholder="Enter budget in $"
                                value={user.budget} onChange={handleInput} name="budget" />
                        </div>

                        <div className="row-inputs">
                            <input type="text" placeholder="How can we help?"
                                value={user.help} onChange={handleInput} name="help" />
                        </div>
                    </div>

                    <div className="error-msg-button">
                        <button onClick={() => sendMessage()} className="submit-btn">
                            <div className="submit">Submit</div>
                        </button>
                        <div className="error-msg">
                            {errorMessage && errorMessage.map((string, index) => (
                                <div key={index}>{string}</div>
                            ))}
                        </div>
                    </div>
                    <br />
                </div>
                <div className="Afterform-container">
                    <div className="Afterform-topic">
                        <h2 className="Afterform-topic">After you submit the form</h2>
                        <ul className="aful-points">
                            <li className="aful-point">
                                <h3>Immediate Confirmation</h3>
                                <span>You’ll receive a confirmation email with a Non-Disclosure Agreement (NDA)
                                    and our portfolio, ensuring that your information stays private.</span>
                            </li>
                            <li className="aful-point">
                                <h3>Discovery Call</h3>
                                <span>Once the NDA is signed, we’ll schedule a call to discuss your
                                    project’s needs and vision in detail.</span>
                            </li>
                            <li className="aful-point">
                                <h3>Custom Proposal</h3>
                                <span>We’ll gather requirements and send you a tailored proposal with
                                    project scope, costs, and timeline.</span>
                            </li>
                            <li className="aful-point">
                                <h3>Project Kickoff</h3>
                                <span>After approval, we’ll begin working on your
                                    project following the agreed plan.</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Form;